import React from 'react';

import { getLocalStorageItem, setLocalStorageItem } from 'utils/localStorage';

type UseLocalStorageProps = {
  key: string;
};

type UseLocalStorageReturn = { value: unknown; setValue: (value: unknown) => void };

const useLocalStorage = ({ key }: UseLocalStorageProps): UseLocalStorageReturn => {
  const [value, setValue] = React.useState(getLocalStorageItem(key));

  const setStorageValue = React.useCallback(
    (newValue: unknown) => {
      setLocalStorageItem(key, newValue);
    },
    [key]
  );

  React.useEffect(() => {
    const onChange = () => {
      setValue(getLocalStorageItem(key));
    };

    window.addEventListener('localstorage', onChange);
    return () => {
      window.removeEventListener('localstorage', onChange);
    };
  }, []);

  return React.useMemo(
    () => ({
      value,
      setValue: setStorageValue,
    }),
    [value, setStorageValue]
  );
};

export default useLocalStorage;
